import React from 'react';
import PropTypes from 'prop-types';

import Preview from './FontPreview.styled';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
const FontPreview = ({ children, fontFamily, fontLibrary = 'google' }) => (
  <Preview fontFamily={fontFamily}>{children}</Preview>
);

FontPreview.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
};

export default FontPreview;
